
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'eddydata-lib';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EditorModule } from 'primeng/editor';
import { ToastModule } from 'primeng/toast';
import { AvisoListComponent } from './aviso-list/aviso-list.component';
import { AvisoRoutingModule } from './aviso-routing.module';
import { AvisoFormComponent } from './aviso-form/aviso-form.component';
import { AvisoService } from './service/aviso.service';
import { AvisoStorageComponent } from './aviso-storage/aviso-storage.component';
import { FileUploadModule } from 'primeng/fileupload';

@NgModule({
    declarations: [
        AvisoListComponent,
        AvisoFormComponent,
        AvisoStorageComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        AvisoRoutingModule,
        AutoCompleteModule,
        CalendarModule,
        ConfirmDialogModule,
        EditorModule,
        ToastModule,
        FileUploadModule,
    ],
    exports: [],
    providers: [MessageService, ConfirmationService, AvisoService]
})
export class AvisoModule { }